import { render, staticRenderFns } from "./PT300RelationParts.vue?vue&type=template&id=3bb4b687&"
import script from "./PT300RelationParts.vue?vue&type=script&lang=js&"
export * from "./PT300RelationParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports